function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function debounce(function_) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof function_ !== 'function') {
    throw new TypeError("Expected the first parameter to be a function, got `".concat(_typeof(function_), "`."));
  }

  if (wait < 0) {
    throw new RangeError('`wait` must not be negative.');
  } // TODO: Deprecate the boolean parameter at some point.


  var _ref = typeof options === 'boolean' ? {
    immediate: options
  } : options,
      immediate = _ref.immediate;

  var storedContext;
  var storedArguments;
  var timeoutId;
  var timestamp;
  var result;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeoutId = setTimeout(later, wait - last);
    } else {
      timeoutId = undefined;

      if (!immediate) {
        var callContext = storedContext;
        var callArguments = storedArguments;
        storedContext = undefined;
        storedArguments = undefined;
        result = function_.apply(callContext, callArguments);
      }
    }
  }

  var debounced = function debounced() {
    if (storedContext && this !== storedContext) {
      throw new Error('Debounced method called with different contexts.');
    }

    storedContext = this; // eslint-disable-line unicorn/no-this-assignment

    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    storedArguments = arguments_;
    timestamp = Date.now();
    var callNow = immediate && !timeoutId;

    if (!timeoutId) {
      timeoutId = setTimeout(later, wait);
    }

    if (callNow) {
      var callContext = storedContext;
      var callArguments = storedArguments;
      storedContext = undefined;
      storedArguments = undefined;
      result = function_.apply(callContext, callArguments);
    }

    return result;
  };

  debounced.clear = function () {
    if (!timeoutId) {
      return;
    }

    clearTimeout(timeoutId);
    timeoutId = undefined;
  };

  debounced.flush = function () {
    if (!timeoutId) {
      return;
    }

    var callContext = storedContext;
    var callArguments = storedArguments;
    storedContext = undefined;
    storedArguments = undefined;
    result = function_.apply(callContext, callArguments);
    clearTimeout(timeoutId);
    timeoutId = undefined;
  };

  return debounced;
} // Adds compatibility for ES modules


module.exports.debounce = debounce;
module.exports = debounce;